import { render, staticRenderFns } from "./RemoveItemFromCart.vue?vue&type=template&id=374aad59&scoped=true"
import script from "./RemoveItemFromCart.vue?vue&type=script&lang=js"
export * from "./RemoveItemFromCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374aad59",
  null
  
)

export default component.exports